module.exports = __webpack_public_path__ + "static/media/bannerCambio.8bd954a9.png";